import React, { Component } from 'react';
import { ButtonGroup, Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import TablePaginator from '../../containers/TablePaginator/TablePaginator';
import ListActions from '../../containers/ListActions/ListActions';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj, download } from '../../actions';
import { emptyMessage, currencyFormatter, dateFormatter } from '../../utils/utils';
import DownloadActions from '../../containers/DownloadActions/DownloadActions';

class DespesaList extends Component {

    state = {
        url: '/despesas'
    }

    componentDidMount() {
        this.props.fetchObjs(this.state.url);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="6" sm="6">
                                        <strong>Despesas</strong>
                                    </Col>
                                    <Col xs="6" sm="6" style={{ textAlign: 'right' }}>
                                        <ButtonGroup>
                                            <Button type="button" size="sm" color="primary" onClick={() => this.props.history.push(`${this.state.url}/new`)}>
                                                <i className="fa fa-plus"></i> Novo
                                        </Button>
                                            <DownloadActions body={this.props.despesas.length !== 0 ? this.props.despesas : null} />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.props.despesas.length === 0 ? emptyMessage : ([
                                    <Table key="table" hover bordered striped responsive size="sm">
                                        <thead key="thead" >
                                            <tr key="head">
                                                <th key="id">Código</th>
                                                <th key="data">Data</th>
                                                <th key="valor">Valor</th>
                                                <th key="descricao">Descrição</th>
                                                <th key="tipo">Tipo</th>
                                                <th xs="12" sm="1" key="acoes" className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody key="tbody" >
                                            {this.props.despesas.map((despesa, i) => {
                                                return (
                                                    <tr key={`tr${i}`} >
                                                        <td key={`id${i}`} onClick={() => this.props.history.push(`${this.state.url}/${despesa.ID}`)}>{despesa ? despesa.ID : ''}</td>
                                                        <td key={`data${i}`} onClick={() => this.props.history.push(`${this.state.url}/${despesa.ID}`)}>{despesa && despesa.DATA ? dateFormatter(new Date(despesa.DATA)) : ''}</td>
                                                        <td key={`valor${i}`} onClick={() => this.props.history.push(`${this.state.url}/${despesa.ID}`)}>{despesa ? currencyFormatter.format(despesa.VALOR) : ''}</td>
                                                        <td key={`descricao${i}`} onClick={() => this.props.history.push(`${this.state.url}/${despesa.ID}`)}>{despesa ? despesa.DESCRICAO : ''}</td>
                                                        <td key={`tipo${i}`} onClick={() => this.props.history.push(`${this.state.url}/${despesa.ID}`)}>{despesa && despesa.tipoDespesa ? despesa.tipoDespesa.DESCRICAO : ''}</td>
                                                        <td key={`actions${i}`}><ListActions {...this.props} {...this.state} id={despesa.ID} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>,
                                    <TablePaginator key="paginator" {...this.props} {...this.state} />
                                ])}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        despesas: state.obj.records ? state.obj.records : [],
        meta: state.obj.meta ? state.obj.meta : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj, download })(DespesaList);

